import { useStableReadQuery } from 'commons/hooks/react-query/useStableReadQuery'
import { getQRDetailsWebPage } from 'commons/service/bank/qr'
import { QRWebPagePayload, QuarterlyReportWebPage } from 'commons/types/DTO/bank/quarterlyReport'

type UseGetQROptions = {
  clearOnUnmount?: boolean
}

export const useGetQRWebPage = (opts?: QRWebPagePayload, options?: UseGetQROptions) => {
  return useStableReadQuery<QuarterlyReportWebPage, QRWebPagePayload | undefined>('qr', opts, getQRDetailsWebPage, {
    placeholderDataKeepPrevious: true,
    forceFreshOnMount: true,
    clearOnUnmount: options?.clearOnUnmount,
    requireVariables: true
  })
}
